import { Heading, HeadingLevel } from 'blaze-ui/Heading/Heading'
import Styles from './Section.module.scss'
import cx from 'classnames'
import { ReactNode } from 'react'
import { Carousel } from 'components/Carousel/Carousel'
import { Size } from 'screens/blaze/Search/utils'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  title?: string
  actionLeft?: ReactNode
  actionCenter?: ReactNode
  actionRight?: ReactNode
  children?: ReactNode
  scrollable?: boolean
  titleLevel?: HeadingLevel
  size?: Size
  carouselStyles?: {
    paddingTop: number
  }
}

export const Section = ({
  title,
  actionCenter,
  actionRight,
  actionLeft,
  children,
  scrollable = true,
  titleLevel = 3,
  size = 'md',
  carouselStyles,
}: Props) => {
  const { isMobile } = useResponsiveDesign()
  if (!children) return null

  return (
    <div className={cx(Styles.section, Styles[size])}>
      <div className={Styles.header}>
        {actionLeft ? (
          <div className={Styles.actionLeft}>{actionLeft}</div>
        ) : (
          <Heading level={titleLevel}>{title}</Heading>
        )}
        <div className={Styles.actionCenter}>{actionCenter}</div>
        {!isMobile && <div className={Styles.actionRight}>{actionRight}</div>}
      </div>
      <div
        style={carouselStyles}
        className={cx(Styles.content, {
          [Styles.carousel]: scrollable,
        })}
      >
        <>
          {scrollable ? (
            <Carousel
              offset={size === 'xs' || isMobile ? 25 : 48}
              withControls
              options={{ slidesToScroll: 2 }}
              buttonSize={size === 'xs' || isMobile ? 'sm' : 'md'}
            >
              {children}
            </Carousel>
          ) : (
            <>{children}</>
          )}
        </>
      </div>
    </div>
  )
}
